<div class="atn-navbar-app-list">
  @if (store.isOnAdminPageSg()) {
    <atn-navbar-app-list-item
      class="atn-navbar-app-list__item"
      name="Tenants"
      icon="atn-icon atn-shield-user atn-light"
      [url]="adminContexts.selectors.getUrlForTenants().asSignal()"
      [active]="adminContexts.selectors.isCurrentlyOnTenants.asSignal()"
    />
    @if (isPlatformAdminSg()) {
      <atn-ds-divider />
      <atn-navbar-app-list-item
        class="atn-navbar-app-list__item"
        name="Users"
        icon="atn-icon atn-group atn-light"
        [url]="adminContexts.selectors.getUrlForUsers().asSignal()"
        [active]="adminContexts.selectors.isCurrentlyOnUsers.asSignal()"
      />
      <atn-ds-divider />
      <atn-navbar-app-list-item
        class="atn-navbar-app-list__item"
        name="Knowledge Bases"
        icon="atn-icon atn-file atn-light"
        [url]="adminContexts.selectors.getUrlForKnowledgeBases().asSignal()"
        [active]="
          adminContexts.selectors.isCurrentlyOnKnowledgeBases.asSignal()
        "
      />
    }
  } @else if (store.isOnGraphqlSandboxPageSg()) {
    <!-- Nothing to show for GraphQL Sandbox -->
  } @else if (store.isNotInTenantSg()) {
    <!-- Nothing to show if we are not focused on a tenant -->
  } @else {
    @if (isAppsSettledSg()) {
      @let canAccessHome =
        meFeature.contexts.selectors.canAccessHome.asSignal();

      @if (canAccessHome) {
        <atn-navbar-app-list-item
          class="atn-navbar-app-list__item"
          name="Home"
          icon="home"
          [url]="meFeature.contexts.selectors.urlForHome.asSignal()"
          [active]="meFeature.contexts.selectors.isCurrentlyOnHome.asSignal()"
        />
      }

      @for (app of appsSg(); track $index) {
        @if (canAccessHome || $index !== 0) {
          <!-- Only need divider if the Home item or another app item is above this one -->
          <atn-ds-divider />
        }

        <atn-navbar-app-list-item
          class="atn-navbar-app-list__item"
          [name]="app.name"
          [icon]="app.icon"
          [app]="app"
          [active]="
            !navigationFeature.selectors.isTransitioning.asSignal() &&
            meFeature.contexts.selectors.isCurrentlyOnApp(app).asSignal()
          "
        />
      }
    }
  }
</div>
